import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Calendar, Clock, RefreshCw, Info, Lock, CreditCard } from 'lucide-react';
import { SEOHead } from '../components/SEOHead';
// --- Custom Bespoke SVG Illustrations ---
const AirbnbHeaderIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-401">
    <circle cx="32" cy="32" r="30" stroke="#1B1B2F" strokeWidth="2" strokeDasharray="4 4" fill="#E8F6F5" data-id="element-402" />
    <path d="M32 16 L16 30 L20 30 L20 46 L44 46 L44 30 L48 30 Z" fill="#2BBCB3" data-id="element-403" />
    <rect x="28" y="34" width="8" height="12" fill="#1B1B2F" data-id="element-404" />
    <circle cx="34" cy="40" r="1" fill="#F5C842" data-id="element-405" />
    <path d="M42 22 L42 18 L46 18 L46 26 Z" fill="#F5C842" data-id="element-406" />
  </svg>;
const DishwasherIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-407">
    <rect x="12" y="12" width="40" height="40" rx="4" fill="#1B1B2F" data-id="element-408" />
    <rect x="16" y="16" width="32" height="8" rx="2" fill="#2BBCB3" data-id="element-409" />
    <rect x="16" y="28" width="32" height="20" rx="2" fill="#E8F6F5" data-id="element-410" />
    <circle cx="24" cy="38" r="6" fill="#F5C842" data-id="element-411" />
    <circle cx="40" cy="38" r="6" fill="#F5C842" data-id="element-412" />
    <path d="M16 28 L48 28" stroke="#1B1B2F" strokeWidth="2" data-id="element-413" />
  </svg>;
const SheetsIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-414">
    <rect x="12" y="24" width="40" height="20" rx="4" fill="#1B1B2F" data-id="element-415" />
    <rect x="16" y="20" width="14" height="8" rx="2" fill="#F5C842" data-id="element-416" />
    <rect x="34" y="20" width="14" height="8" rx="2" fill="#F5C842" data-id="element-417" />
    <path d="M12 34 L52 34 L52 44 L12 44 Z" fill="#2BBCB3" data-id="element-418" />
    <path d="M12 34 Q32 24 52 34" fill="#E8F6F5" data-id="element-419" />
    <rect x="16" y="44" width="4" height="6" fill="#1B1B2F" data-id="element-420" />
    <rect x="44" y="44" width="4" height="6" fill="#1B1B2F" data-id="element-421" />
  </svg>;
const LaundryIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-422">
    <rect x="14" y="10" width="36" height="44" rx="4" fill="#1B1B2F" data-id="element-423" />
    <rect x="18" y="14" width="28" height="8" rx="2" fill="#2BBCB3" data-id="element-424" />
    <circle cx="32" cy="36" r="12" fill="#E8F6F5" data-id="element-425" />
    <circle cx="32" cy="36" r="8" fill="#2BBCB3" fillOpacity="0.3" data-id="element-426" />
    <circle cx="22" cy="18" r="2" fill="#1B1B2F" data-id="element-427" />
    <circle cx="28" cy="18" r="2" fill="#1B1B2F" data-id="element-428" />
  </svg>;
const FacadeWindowsIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-429">
    <rect x="12" y="12" width="40" height="40" rx="2" fill="#1B1B2F" data-id="element-430" />
    <rect x="16" y="16" width="14" height="16" fill="#E8F6F5" data-id="element-431" />
    <rect x="34" y="16" width="14" height="16" fill="#E8F6F5" data-id="element-432" />
    <rect x="16" y="36" width="14" height="12" fill="#E8F6F5" data-id="element-433" />
    <rect x="34" y="36" width="14" height="12" fill="#E8F6F5" data-id="element-434" />
    <path d="M12 34 L52 34" stroke="#2BBCB3" strokeWidth="2" data-id="element-435" />
    <path d="M32 12 L32 52" stroke="#2BBCB3" strokeWidth="2" data-id="element-436" />
  </svg>;
const FirstDeepCleaningIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-437">
    <path d="M16 16 L48 16 L48 48 L16 48 Z" fill="#1B1B2F" data-id="element-438" />
    <path d="M24 32 L32 24 L40 32 L32 40 Z" fill="#F5C842" data-id="element-439" />
    <circle cx="20" cy="20" r="2" fill="#2BBCB3" data-id="element-440" />
    <circle cx="44" cy="44" r="2" fill="#2BBCB3" data-id="element-441" />
    <circle cx="44" cy="20" r="1" fill="#E8F6F5" data-id="element-442" />
    <circle cx="20" cy="44" r="1" fill="#E8F6F5" data-id="element-443" />
  </svg>;
const CabinetsIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-444">
    <rect x="12" y="12" width="40" height="40" rx="2" fill="#1B1B2F" data-id="element-445" />
    <rect x="14" y="14" width="17" height="36" fill="#2BBCB3" data-id="element-446" />
    <rect x="33" y="14" width="17" height="36" fill="#2BBCB3" data-id="element-447" />
    <rect x="27" y="30" width="2" height="8" fill="#1B1B2F" data-id="element-448" />
    <rect x="35" y="30" width="2" height="8" fill="#1B1B2F" data-id="element-449" />
  </svg>;
const BasementIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-450">
    <path d="M12 12 L32 12 L32 28 L48 28 L48 44 L52 44 L52 52 L12 52 Z" fill="#1B1B2F" data-id="element-451" />
    <rect x="16" y="36" width="12" height="12" rx="2" fill="#F5C842" data-id="element-452" />
    <rect x="36" y="32" width="8" height="8" rx="1" fill="#2BBCB3" data-id="element-453" />
  </svg>;
const FluBusterIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-454">
    <path d="M32 12 C42 12 50 20 50 32 C50 48 32 56 32 56 C32 56 14 48 14 32 C14 20 22 12 32 12 Z" fill="#2BBCB3" data-id="element-455" />
    <path d="M32 20 L32 44 M20 32 L44 32" stroke="#FFFFFF" strokeWidth="4" strokeLinecap="round" data-id="element-456" />
    <circle cx="44" cy="20" r="4" fill="#E85D4A" data-id="element-457" />
    <circle cx="20" cy="44" r="3" fill="#F5C842" data-id="element-458" />
  </svg>;
const BaseboardsIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-459">
    <rect x="12" y="12" width="40" height="32" fill="#E8F6F5" data-id="element-460" />
    <rect x="12" y="44" width="40" height="8" fill="#1B1B2F" data-id="element-461" />
    <path d="M24 36 Q32 28 40 36" stroke="#2BBCB3" strokeWidth="4" strokeLinecap="round" data-id="element-462" />
    <circle cx="40" cy="36" r="4" fill="#F5C842" data-id="element-463" />
  </svg>;
const InteriorWindowGlassIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-464">
    <rect x="16" y="12" width="32" height="40" rx="2" fill="#1B1B2F" data-id="element-465" />
    <rect x="20" y="16" width="24" height="32" fill="#E8F6F5" data-id="element-466" />
    <path d="M24 20 L36 44 M32 20 L40 36" stroke="#2BBCB3" strokeWidth="2" strokeOpacity="0.5" data-id="element-467" />
    <circle cx="38" cy="24" r="2" fill="#F5C842" data-id="element-468" />
  </svg>;
const BlindsIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-469">
    <rect x="16" y="12" width="32" height="6" rx="1" fill="#1B1B2F" data-id="element-470" />
    <rect x="18" y="22" width="28" height="4" fill="#2BBCB3" data-id="element-471" />
    <rect x="18" y="30" width="28" height="4" fill="#2BBCB3" data-id="element-472" />
    <rect x="18" y="38" width="28" height="4" fill="#2BBCB3" data-id="element-473" />
    <rect x="18" y="46" width="28" height="4" fill="#2BBCB3" data-id="element-474" />
    <rect x="42" y="18" width="2" height="36" fill="#1B1B2F" data-id="element-475" />
    <circle cx="43" cy="54" r="3" fill="#E85D4A" data-id="element-476" />
  </svg>;
const PropertyCleanupIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-477">
    <path d="M32 12 L12 28 L16 28 L16 48 L48 48 L48 28 L52 28 Z" fill="#1B1B2F" data-id="element-478" />
    <rect x="28" y="36" width="8" height="12" fill="#E8F6F5" data-id="element-479" />
    <path d="M40 32 L46 20 L48 22 L42 34 Z" fill="#F5C842" data-id="element-480" />
    <circle cx="46" cy="20" r="3" fill="#2BBCB3" data-id="element-481" />
    <path d="M18 48 L26 40 L30 48 Z" fill="#E85D4A" data-id="element-482" />
  </svg>;
const PatioIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-483">
    <rect x="12" y="40" width="40" height="8" rx="2" fill="#1B1B2F" data-id="element-484" />
    <rect x="16" y="24" width="4" height="16" fill="#1B1B2F" data-id="element-485" />
    <rect x="28" y="24" width="4" height="16" fill="#1B1B2F" data-id="element-486" />
    <rect x="44" y="24" width="4" height="16" fill="#1B1B2F" data-id="element-487" />
    <rect x="12" y="20" width="40" height="4" rx="1" fill="#1B1B2F" data-id="element-488" />
    <circle cx="32" cy="14" r="6" fill="#F5C842" data-id="element-489" />
    <path d="M26 14 Q32 8 38 14" stroke="#E85D4A" strokeWidth="2" fill="none" data-id="element-490" />
  </svg>;
const CarpetSteamIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-491">
    <rect x="16" y="28" width="32" height="16" rx="2" fill="#1B1B2F" data-id="element-492" />
    <rect x="20" y="20" width="24" height="8" rx="2" fill="#2BBCB3" data-id="element-493" />
    <path d="M24 44 L40 44 L44 52 L20 52 Z" fill="#E8F6F5" data-id="element-494" />
    <path d="M24 52 Q32 58 40 52" stroke="#F5C842" strokeWidth="2" fill="none" data-id="element-495" />
    <circle cx="32" cy="36" r="4" fill="#F5C842" data-id="element-496" />
  </svg>;
const AreaRugsIcon = () => <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-497">
    <path d="M16 20 C16 16 24 16 24 20 L24 44 C24 48 16 48 16 44 Z" fill="#2BBCB3" data-id="element-498" />
    <path d="M24 20 L48 32 L48 52 L24 44 Z" fill="#1B1B2F" data-id="element-499" />
    <path d="M24 24 L44 34 M24 32 L44 42" stroke="#E8F6F5" strokeWidth="2" data-id="element-500" />
    <circle cx="20" cy="20" r="2" fill="#F5C842" data-id="element-501" />
  </svg>;
export function AirbnbForm() {
  // Step 3 State
  const [parking, setParking] = useState('Free on street');
  const [lastCleaning, setLastCleaning] = useState('< 1 month');
  const [pets, setPets] = useState('None');
  const [supplies, setSupplies] = useState('No');
  // Step 4 State (Extras)
  const [selectedExtras, setSelectedExtras] = useState<string[]>([]);
  const toggleExtra = (id: string) => {
    setSelectedExtras(prev => prev.includes(id) ? prev.filter(e => e !== id) : [...prev, id]);
  };
  const extrasList = [{
    id: 'dishwasher',
    label: 'Washing dishes',
    icon: DishwasherIcon
  }, {
    id: 'sheets',
    label: 'Change Sheets',
    icon: SheetsIcon
  }, {
    id: 'laundry',
    label: 'Laundry (wash & fold)',
    icon: LaundryIcon
  }, {
    id: 'facade',
    label: 'Inside facade of windows',
    icon: FacadeWindowsIcon
  }, {
    id: 'first',
    label: 'First or Deep Cleaning',
    icon: FirstDeepCleaningIcon
  }, {
    id: 'cabinets',
    label: 'Interior & Exterior of Kitchen Cabinets',
    icon: CabinetsIcon
  }, {
    id: 'basement',
    label: 'Finished Basement',
    icon: BasementIcon
  }, {
    id: 'flu',
    label: 'Flu Buster - Eucalyptus',
    icon: FluBusterIcon
  }, {
    id: 'baseboards',
    label: 'Hand Wipe Baseboards',
    icon: BaseboardsIcon
  }, {
    id: 'interiorglass',
    label: 'Interior Window Glass',
    icon: InteriorWindowGlassIcon
  }, {
    id: 'blinds',
    label: 'Wet Wipe Blinds',
    icon: BlindsIcon
  }, {
    id: 'property',
    label: 'Property Cleanup',
    icon: PropertyCleanupIcon
  }, {
    id: 'patio',
    label: 'Patio or Balcony',
    icon: PatioIcon
  }, {
    id: 'carpet',
    label: 'Carpet Steam Clean - Entire Home',
    icon: CarpetSteamIcon
  }, {
    id: 'rugs',
    label: 'Area Rugs Steam Cleaning',
    icon: AreaRugsIcon
  }];
  // Step 5 State
  const [bookingBundle, setBookingBundle] = useState('1 Service');
  // Step 6 State
  const [selectedDate, setSelectedDate] = useState('04/04');
  const [selectedTime, setSelectedTime] = useState('14:00');
  const dates = [{
    day: 'M',
    date: '30/03'
  }, {
    day: 'Tu',
    date: '31/03'
  }, {
    day: 'W',
    date: '01/04'
  }, {
    day: 'Th',
    date: '02/04'
  }, {
    day: 'F',
    date: '03/04'
  }, {
    day: 'Sa',
    date: '04/04'
  }, {
    day: 'Su',
    date: '05/04'
  }];
  // Step 7 State
  const [paymentMethod, setPaymentMethod] = useState('By Credit/Debit Card');
  const StepHeading = ({
    number,
    title,
    subtitle
  }: {
    number: string;
    title: string;
    subtitle?: string;
  }) => <div className="mb-8" data-id="element-502">
      <div className="flex items-center gap-4 mb-2" data-id="element-503">
        <div className="w-10 h-10 rounded-full bg-accent flex items-center justify-center text-white font-heading font-bold text-xl shadow-md shrink-0" data-id="element-504">
          {number}
        </div>
        <h3 className="text-2xl md:text-3xl font-heading font-bold text-primary uppercase tracking-wide" data-id="element-505">
          {title}
        </h3>
      </div>
      {subtitle && <p className="text-gray-500 text-base ml-14 pb-4 border-b border-gray-100" data-id="element-506">
          {subtitle}
        </p>}
      {!subtitle && <div className="ml-14 pb-4 border-b border-gray-100" data-id="element-507"></div>}
    </div>;
  return <main className="min-h-screen bg-light pb-24" data-id="element-508">
      <SEOHead title="Book Airbnb / Short Term Rental Cleaning | Smith & Jengs" description="Fast, reliable Airbnb and short-term rental turnover cleaning in Bicester. Keep your guests happy with a spotless property every time." data-id="element-509" />
      {/* Dark Page Hero */}
      <section className="bg-primary pt-36 md:pt-44 pb-16 md:pb-24 relative overflow-hidden" data-id="element-510">
        <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
        backgroundImage: 'radial-gradient(rgba(255,255,255,0.15) 1px, transparent 1px)',
        backgroundSize: '24px 24px'
      }} data-id="element-511"></div>
        <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-512">
          <div className="text-sm font-medium text-white/50 mb-6 uppercase tracking-wider" data-id="element-513">
            <Link to="/" className="hover:text-accent transition-colors" data-id="element-514">
              Home
            </Link>
            <span className="mx-2" data-id="element-515">/</span>
            <Link to="/services" className="hover:text-accent transition-colors" data-id="element-516">
              Our Services
            </Link>
            <span className="mx-2" data-id="element-517">/</span>
            <span className="text-accent" data-id="element-518">Book Online</span>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-519">
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-heading font-bold text-white uppercase leading-none tracking-tight mb-4" data-id="element-520">
              Airbnb / Short Term Rental
            </h1>
            <p className="text-xl md:text-2xl font-serif italic text-white/60" data-id="element-521">
              Book Online in 60 Seconds
            </p>
          </motion.div>
        </div>
      </section>

      {/* Form & Sidebar Container */}
      <div className="container mx-auto px-6 md:px-12 -mt-8 relative z-20" data-id="element-522">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start" data-id="element-523">
          {/* Main Form Area */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="lg:col-span-8 xl:col-span-9 bg-white rounded-2xl shadow-xl p-8 md:p-12 border border-gray-100" data-id="element-524">
            <div className="text-center mb-16 flex flex-col items-center" data-id="element-525">
              <div className="w-24 h-24 rounded-full border-2 border-accent/20 flex items-center justify-center mb-6 bg-accent/5" data-id="element-526">
                <AirbnbHeaderIcon data-id="element-527" />
              </div>
              <h2 className="text-3xl md:text-5xl font-heading font-bold text-primary uppercase tracking-wide mb-3" data-id="element-528">
                Airbnb - Short Term Rental Cleaning
              </h2>
              <p className="text-gray-500 text-lg max-w-2xl mx-auto" data-id="element-529">
                It only takes 60 seconds to Book your Home Cleaning!
              </p>
              <span className="text-accent text-sm font-bold uppercase tracking-widest mt-4" data-id="element-530">
                Airbnb or Short Term Rental Cleaning
              </span>
            </div>

            <form className="space-y-20" onSubmit={e => e.preventDefault()} data-id="element-531">
              {/* STEP 1 */}
              <section data-id="element-532">
                <StepHeading number="1" title="Contact Information" data-id="element-533" />
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 ml-0 md:ml-14" data-id="element-534">
                  <input type="text" placeholder="First Name" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-535" />
                  <input type="text" placeholder="Last Name" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-536" />
                  <input type="email" placeholder="Email" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-537" />
                  <div className="flex rounded-xl border border-gray-200 bg-gray-50 focus-within:bg-white focus-within:ring-2 focus-within:ring-accent focus-within:border-accent transition-all overflow-hidden" data-id="element-538">
                    <div className="px-4 py-4 border-r border-gray-200 bg-gray-100 flex items-center justify-center text-gray-600 font-medium" data-id="element-539">
                      🇬🇧 ▾
                    </div>
                    <input type="tel" placeholder="Phone Number" className="w-full px-5 py-4 outline-none bg-transparent text-primary" data-id="element-540" />
                  </div>
                </div>
              </section>

              {/* STEP 2 */}
              <section data-id="element-541">
                <StepHeading number="2" title="Cleaning Location" data-id="element-542" />
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 ml-0 md:ml-14" data-id="element-543">
                  <input type="text" placeholder="Enter a location" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-544" />
                  <input type="text" placeholder="Unit/Apt/Suite #" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-545" />
                  <input type="text" placeholder="City" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-546" />
                  <input type="text" placeholder="Postal Code" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-547" />
                </div>
                <div className="ml-0 md:ml-14 mt-4" data-id="element-548">
                  <a href="#" className="text-accent hover:text-primary transition-colors flex items-center gap-2 font-medium" data-id="element-549">
                    See what's included in our Airbnb - Short Term Rental
                    Cleaning <Info size={16} data-id="element-550" />
                  </a>
                </div>
              </section>

              {/* STEP 3 */}
              <section data-id="element-551">
                <StepHeading number="3" title="Tell us about the cleaning" data-id="element-552" />
                <div className="space-y-8 ml-0 md:ml-14" data-id="element-553">
                  <div data-id="element-554">
                    <label className="text-primary font-medium block mb-3 text-lg" data-id="element-555">
                      How many hours and cleaners would you like to book?
                    </label>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-556">
                      <select className="w-full px-5 py-3.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary appearance-none cursor-pointer" data-id="element-557">
                        <option data-id="element-558">2 Hours</option>
                        <option data-id="element-559">3 Hours</option>
                        <option data-id="element-560">4 Hours</option>
                        <option data-id="element-561">5 Hours</option>
                        <option data-id="element-562">6 Hours</option>
                        <option data-id="element-563">7 Hours</option>
                        <option data-id="element-564">8 Hours</option>
                      </select>
                      <select className="w-full px-5 py-3.5 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary appearance-none cursor-pointer" data-id="element-565">
                        <option data-id="element-566">1 Cleaner</option>
                        <option selected data-id="element-567">2 Cleaners</option>
                        <option data-id="element-568">3 Cleaners</option>
                      </select>
                    </div>
                  </div>

                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors border border-transparent hover:border-gray-100" data-id="element-569">
                    <label className="text-primary font-medium text-lg" data-id="element-570">
                      Bedrooms
                    </label>
                    <select className="w-full sm:w-48 px-4 py-3 rounded-xl border border-gray-200 bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary font-medium appearance-none cursor-pointer shadow-sm" data-id="element-571">
                      <option data-id="element-572">Studio / 1 Bedroom</option>
                      <option data-id="element-573">2 Bedrooms</option>
                      <option data-id="element-574">3 Bedrooms</option>
                      <option data-id="element-575">4 Bedrooms</option>
                      <option data-id="element-576">5+ Bedrooms</option>
                    </select>
                  </div>

                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors border border-transparent hover:border-gray-100" data-id="element-577">
                    <label className="text-primary font-medium text-lg" data-id="element-578">
                      Bathrooms
                    </label>
                    <select className="w-full sm:w-48 px-4 py-3 rounded-xl border border-gray-200 bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary font-medium appearance-none cursor-pointer shadow-sm" data-id="element-579">
                      <option data-id="element-580">1 Bathroom</option>
                      <option data-id="element-581">2 Bathrooms</option>
                      <option data-id="element-582">3 Bathrooms</option>
                      <option data-id="element-583">4+ Bathrooms</option>
                    </select>
                  </div>

                  <div data-id="element-584">
                    <label className="text-primary font-medium block mb-3 text-lg" data-id="element-585">
                      Parking
                    </label>
                    <div className="flex flex-wrap rounded-xl overflow-hidden border border-gray-200 shadow-sm w-full" data-id="element-586">
                      {['Free on street', 'Free home parking', 'Parking meters', 'Paid parking lot'].map(opt => <button key={opt} type="button" onClick={() => setParking(opt)} className={`flex-1 min-w-[140px] py-3.5 px-4 text-sm font-medium transition-all duration-300 ${parking === opt ? 'bg-accent text-white shadow-inner' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'} border-r border-b sm:border-b-0 border-gray-200 last:border-r-0`} data-id="element-587">
                          {opt}
                        </button>)}
                    </div>
                  </div>

                  <div data-id="element-588">
                    <label className="text-primary font-medium block mb-3 text-lg" data-id="element-589">
                      When was your last full cleaning?
                    </label>
                    <div className="flex rounded-xl overflow-hidden border border-gray-200 shadow-sm w-full max-w-sm" data-id="element-590">
                      {['< 1 month', "I'm too embarrassed to say"].map(opt => <button key={opt} type="button" onClick={() => setLastCleaning(opt)} className={`flex-1 py-3.5 px-4 text-sm font-medium transition-all duration-300 ${lastCleaning === opt ? 'bg-accent text-white shadow-inner' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'} border-r border-gray-200 last:border-r-0`} data-id="element-591">
                            {opt}
                          </button>)}
                    </div>
                  </div>

                  <div data-id="element-592">
                    <label className="text-primary font-medium block mb-3 text-lg" data-id="element-593">
                      Do you have any pets? (Required for safety & allergy
                      reasons)
                    </label>
                    <div className="flex rounded-xl overflow-hidden border border-gray-200 shadow-sm w-full max-w-sm" data-id="element-594">
                      {['None', 'Dog', 'Cat'].map(opt => <button key={opt} type="button" onClick={() => setPets(opt)} className={`flex-1 py-3.5 px-4 text-sm font-medium transition-all duration-300 ${pets === opt ? 'bg-accent text-white shadow-inner' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'} border-r border-gray-200 last:border-r-0`} data-id="element-595">
                          {opt}
                        </button>)}
                    </div>
                  </div>

                  <div data-id="element-596">
                    <label className="text-primary font-medium block mb-3 text-lg" data-id="element-597">
                      All cleaning supplies are included at no extra charge.
                      Would you prefer we use yours?
                    </label>
                    <div className="flex rounded-xl overflow-hidden border border-gray-200 shadow-sm w-full max-w-[200px]" data-id="element-598">
                      {['Yes', 'No'].map(opt => <button key={opt} type="button" onClick={() => setSupplies(opt)} className={`flex-1 py-3.5 px-4 text-sm font-medium transition-all duration-300 ${supplies === opt ? 'bg-accent text-white shadow-inner' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'} border-r border-gray-200 last:border-r-0`} data-id="element-599">
                          {opt}
                        </button>)}
                    </div>
                  </div>
                </div>
              </section>

              {/* STEP 4 */}
              <section data-id="element-600">
                <StepHeading number="4" title="Select Extras" subtitle="Free up more of your precious time for what matters most!" data-id="element-601" />
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 ml-0 md:ml-14" data-id="element-602">
                  {extrasList.map(({
                  id,
                  label,
                  icon: Icon
                }) => {
                  const isSelected = selectedExtras.includes(id);
                  return <button key={id} type="button" onClick={() => toggleExtra(id)} className={`flex flex-col items-center justify-center p-6 rounded-2xl border-2 transition-all duration-300 group ${isSelected ? 'border-accent bg-accent/5 shadow-md' : 'border-gray-100 bg-gray-50 hover:border-accent/30 hover:bg-gray-100'}`} data-id="element-603">
                        <div className={`mb-4 transform transition-transform duration-300 ${isSelected ? 'scale-110' : 'group-hover:scale-105'}`} data-id="element-604">
                          <Icon data-id="element-605" />
                        </div>
                        <span className={`text-sm text-center font-medium ${isSelected ? 'text-primary font-bold' : 'text-gray-600'}`} data-id="element-606">
                          {label}
                        </span>
                      </button>;
                })}
                </div>
              </section>

              {/* STEP 5 */}
              <section data-id="element-607">
                <StepHeading number="5" title="Booking Bundle" subtitle="How many services would you like to purchase at this time?" data-id="element-608" />
                <div className="ml-0 md:ml-14" data-id="element-609">
                  <div className="flex rounded-xl overflow-hidden border border-gray-200 shadow-sm w-full max-w-lg" data-id="element-610">
                    {['1 Service', '5 Services -5%', '10 Services -15%'].map(opt => <button key={opt} type="button" onClick={() => setBookingBundle(opt)} className={`flex-1 py-4 px-4 text-sm font-medium transition-all duration-300 ${bookingBundle === opt ? 'bg-accent text-white shadow-inner' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'} border-r border-gray-200 last:border-r-0`} data-id="element-611">
                          {opt}
                        </button>)}
                  </div>
                </div>
              </section>

              {/* STEP 6 */}
              <section data-id="element-612">
                <StepHeading number="6" title="Pick a date for the cleaning." subtitle="For recurring services, each one will commence on the same day and time as selected for the first service." data-id="element-613" />
                <div className="ml-0 md:ml-14 space-y-8" data-id="element-614">
                  <div className="flex flex-col items-center justify-center bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-615">
                    <span className="font-bold text-primary mb-3" data-id="element-616">
                      Choose a timezone
                    </span>
                    <div className="flex items-center gap-3" data-id="element-617">
                      <span className="text-gray-500 text-sm" data-id="element-618">
                        Our Company's
                      </span>
                      <div className="w-12 h-6 bg-accent rounded-full relative cursor-pointer" data-id="element-619">
                        <div className="absolute right-1 top-1 w-4 h-4 bg-white rounded-full" data-id="element-620"></div>
                      </div>
                      <span className="text-primary font-medium text-sm" data-id="element-621">
                        Yours
                      </span>
                    </div>
                  </div>

                  <div className="border border-gray-200 rounded-xl overflow-hidden shadow-sm" data-id="element-622">
                    <div className="flex justify-between items-center p-4 border-b border-gray-200 bg-gray-50" data-id="element-623">
                      <button type="button" className="text-gray-400 hover:text-accent transition-colors" data-id="element-624">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-625">
                          <circle cx="12" cy="12" r="10" data-id="element-626"></circle>
                          <polyline points="12 8 8 12 12 16" data-id="element-627"></polyline>
                          <line x1="16" y1="12" x2="8" y2="12" data-id="element-628"></line>
                        </svg>
                      </button>
                      <div className="flex gap-2 sm:gap-6 overflow-x-auto px-2 hide-scrollbar" data-id="element-629">
                        {dates.map(d => <button key={d.date} type="button" onClick={() => setSelectedDate(d.date)} className={`flex flex-col items-center p-2 rounded-lg min-w-[60px] transition-colors ${selectedDate === d.date ? 'bg-accent/10 text-accent' : 'hover:bg-gray-100 text-gray-600'}`} data-id="element-630">
                            <span className="text-sm font-medium mb-1" data-id="element-631">
                              {d.day}
                            </span>
                            <span className="text-xs flex items-center gap-1" data-id="element-632">
                              <Calendar size={12} data-id="element-633" />
                              {d.date}
                            </span>
                          </button>)}
                      </div>
                      <button type="button" className="text-gray-400 hover:text-accent transition-colors" data-id="element-634">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-635">
                          <circle cx="12" cy="12" r="10" data-id="element-636"></circle>
                          <polyline points="12 16 16 12 12 8" data-id="element-637"></polyline>
                          <line x1="8" y1="12" x2="16" y2="12" data-id="element-638"></line>
                        </svg>
                      </button>
                    </div>

                    <div className="p-6 bg-white flex flex-col items-end gap-3" data-id="element-639">
                      {['14:00', '15:00'].map(time => <button key={time} type="button" onClick={() => setSelectedTime(time)} className={`flex items-center gap-2 px-6 py-2 rounded-full border transition-all ${selectedTime === time ? 'border-accent bg-accent text-white shadow-md' : 'border-gray-200 text-accent hover:border-accent hover:bg-accent/5'}`} data-id="element-640">
                          <Clock size={16} data-id="element-641" />
                          {time}
                        </button>)}
                    </div>
                  </div>
                  <p className="text-gray-500 text-sm italic" data-id="element-642">
                    For same day bookings, a Customer service agent will call
                    you.
                  </p>

                  <div data-id="element-643">
                    <label className="text-primary font-medium block mb-3 text-lg" data-id="element-644">
                      Are there any additional details we need to know?
                    </label>
                    <textarea className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all min-h-[120px] text-primary resize-y" data-id="element-645"></textarea>
                  </div>
                </div>
              </section>

              {/* STEP 7 */}
              <section data-id="element-646">
                <StepHeading number="7" title="Payment details" subtitle="Select your method of payment. Credit Card charges may be pre-authorised, but applied only after the service event is complete." data-id="element-647" />
                <div className="ml-0 md:ml-14 space-y-6" data-id="element-648">
                  <div className="flex flex-wrap rounded-xl overflow-hidden border border-gray-200 shadow-sm w-full" data-id="element-649">
                    {['By Cash', 'By Check', 'By Credit/Debit Card', 'By Interac e-Transfer'].map(opt => <button key={opt} type="button" onClick={() => setPaymentMethod(opt)} className={`flex-1 min-w-[150px] py-4 px-4 text-sm font-medium transition-all duration-300 ${paymentMethod === opt ? 'bg-accent text-white shadow-inner' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'} border-r border-b sm:border-b-0 border-gray-200 last:border-r-0`} data-id="element-650">
                        {opt}
                      </button>)}
                  </div>

                  {paymentMethod === 'By Credit/Debit Card' && <motion.div initial={{
                  opacity: 0,
                  height: 0
                }} animate={{
                  opacity: 1,
                  height: 'auto'
                }} className="space-y-4" data-id="element-651">
                      <input type="text" placeholder="name on credit card" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-652" />

                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-653">
                        <button type="button" className="flex items-center gap-3 p-4 rounded-xl border-2 border-accent bg-accent/5 text-primary font-medium" data-id="element-654">
                          <CreditCard className="text-accent" data-id="element-655" /> Card
                        </button>
                        <button type="button" className="flex items-center gap-3 p-4 rounded-xl border border-gray-200 bg-white hover:bg-gray-50 text-primary font-medium transition-colors" data-id="element-656">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-657">
                            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" fill="#F5C842" data-id="element-658" />
                            <path d="M15 10.5H9V13.5H15V10.5Z" fill="#1B1B2F" data-id="element-659" />
                          </svg>
                          Google Pay
                        </button>
                      </div>

                      <div className="flex items-center gap-2 text-accent text-sm font-bold mt-2" data-id="element-660">
                        <Lock size={14} data-id="element-661" /> Secure, fast checkout with Link
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-662">
                          <polyline points="6 9 12 15 18 9" data-id="element-663"></polyline>
                        </svg>
                      </div>

                      <div className="grid grid-cols-1 sm:grid-cols-12 gap-4" data-id="element-664">
                        <div className="sm:col-span-6 relative" data-id="element-665">
                          <input type="text" placeholder="Card number" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-666" />
                          <div className="absolute right-4 top-1/2 -translate-y-1/2 flex gap-1" data-id="element-667">
                            <div className="w-8 h-5 bg-blue-800 rounded flex items-center justify-center text-[8px] text-white font-bold" data-id="element-668">
                              VISA
                            </div>
                            <div className="w-8 h-5 bg-orange-500 rounded flex items-center justify-center text-[8px] text-white font-bold" data-id="element-669">
                              MC
                            </div>
                          </div>
                        </div>
                        <input type="text" placeholder="Expiration date" className="sm:col-span-3 w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-670" />
                        <input type="text" placeholder="Security code" className="sm:col-span-3 w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-671" />
                      </div>

                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-672">
                        <select className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary appearance-none cursor-pointer" data-id="element-673">
                          <option data-id="element-674">United Kingdom</option>
                          <option data-id="element-675">United States</option>
                          <option data-id="element-676">Canada</option>
                        </select>
                        <input type="text" placeholder="Postal Code" className="w-full px-5 py-4 rounded-xl border border-gray-200 bg-gray-50 focus:bg-white focus:ring-2 focus:ring-accent focus:border-accent outline-none transition-all text-primary" data-id="element-677" />
                      </div>

                      <p className="text-xs text-gray-500 mt-4 leading-relaxed" data-id="element-678">
                        By providing your card information, you allow Smith and
                        Jengs Cleaning Services to charge your card for future
                        payments in accordance with their terms.
                      </p>
                      <p className="text-xs text-gray-400 text-center italic mt-2" data-id="element-679">
                        I authorise the operator to send instructions to the
                        financial institution that issued my card to take
                        payments from my card account in accordance with the
                        terms of my agreement with you.
                      </p>
                    </motion.div>}

                  <div className="space-y-3 pt-6 flex flex-col items-center" data-id="element-680">
                    <label className="flex items-center gap-3 cursor-pointer group" data-id="element-681">
                      <div className="w-5 h-5 rounded border border-gray-300 flex items-center justify-center group-hover:border-accent transition-colors" data-id="element-682">
                        <div className="w-3 h-3 bg-transparent rounded-sm" data-id="element-683"></div>
                      </div>
                      <span className="text-primary text-lg" data-id="element-684">
                        I would like to be notified by email.
                      </span>
                    </label>
                  </div>
                </div>
              </section>

              {/* Submit */}
              <div className="pt-12 pb-4 flex justify-center border-t border-gray-100" data-id="element-685">
                <button type="submit" className="bg-[#5CB85C] hover:bg-[#4cae4c] text-white px-16 py-4 rounded text-xl font-bold transition-all shadow-md hover:shadow-lg" data-id="element-686">
                  Book Now
                </button>
              </div>
            </form>
          </motion.div>

          {/* Sidebar - Booking Summary */}
          <div className="lg:col-span-4 xl:col-span-3" data-id="element-687">
            <div className="sticky top-32 bg-white rounded-xl shadow-lg border border-gray-100 overflow-hidden" data-id="element-688">
              <div className="bg-gray-50 p-6 border-b border-gray-100" data-id="element-689">
                <h3 className="text-xl font-heading font-bold text-primary uppercase tracking-wide" data-id="element-690">
                  Booking Summary
                </h3>
              </div>

              <div className="p-6 space-y-4 border-b border-gray-100" data-id="element-691">
                <div className="flex items-center gap-3 text-gray-600 text-sm" data-id="element-692">
                  <Calendar size={16} className="text-accent" data-id="element-693" />
                  <span data-id="element-694">4 Apr 2026</span>
                </div>
                <div className="flex items-center gap-3 text-gray-600 text-sm" data-id="element-695">
                  <Clock size={16} className="text-accent" data-id="element-696" />
                  <span data-id="element-697">14:00</span>
                </div>
              </div>

              <div className="p-6 space-y-3 border-b border-gray-100 text-sm" data-id="element-698">
                <div className="flex justify-between text-gray-600" data-id="element-699">
                  <span data-id="element-700">Airbnb - Short Term Rental Cleaning</span>
                  <span data-id="element-701">£70.00</span>
                </div>
                <div className="flex justify-between text-gray-600" data-id="element-702">
                  <span data-id="element-703">DISCOUNTS</span>
                  <span data-id="element-704">£0.00</span>
                </div>
                <div className="flex justify-between text-gray-600" data-id="element-705">
                  <span data-id="element-706">EXTRAS</span>
                  <span data-id="element-707">£0.00</span>
                </div>
              </div>
              <div className="p-6 bg-gray-50 flex justify-between items-center" data-id="element-708">
                <span className="font-bold text-primary text-lg" data-id="element-709">TOTAL</span>
                <span className="font-bold text-primary text-lg" data-id="element-710">£70.00</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>;
}